import { useMemo } from 'react';
import { useLocation } from 'react-router';

import {
  documentBuilderBlockPath,
  documentBuilderBlocksPath,
  documentBuilderTemplatePath,
  documentBuilderTemplatesPath,
  isDocumentBuilderHosted,
  resolveDocumentBuilderBasePath
} from './documentBuilderPaths';

export function useDocumentBuilderPaths() {
  const { pathname } = useLocation();

  return useMemo(
    () => ({
      basePath: resolveDocumentBuilderBasePath(pathname),
      isHosted: isDocumentBuilderHosted(pathname),
      blocksPath: () => documentBuilderBlocksPath(pathname),
      templatesPath: () => documentBuilderTemplatesPath(pathname),
      blockPath: (blockId: string) => documentBuilderBlockPath(blockId, pathname),
      templatePath: (templateId: string) => documentBuilderTemplatePath(templateId, pathname)
    }),
    [pathname]
  );
}
